module.exports = __webpack_public_path__ + "static/media/profile.4312b1c2.jpg";